import React from 'react'
import { useAuth } from '../../../../context/AuthContext'
import './index.css'

function GoogleLoginButton() {
  const { user, loginWithGoogle, logout } = useAuth()

  return (
    <div>
        <button type="button" className="login-with-google-btn" onClick={loginWithGoogle}>
          Sign in with Google
        </button>
    </div>
  )
}

export default GoogleLoginButton
